import CONSTANTS from '@/constants'
import api from './api'

const settings = {
	get() {
		return api.get(`${CONSTANTS.API_BASE_URL}/api/settings`)
	},
	update(params) {
		return api.post(`${CONSTANTS.API_BASE_URL}/api/settings`, params)
	},
}

export default settings
